// extracted by mini-css-extract-plugin
export default {"Score":"CandidateScore_Score__o5beg"};